import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AiCostCard = () => {
  const [day, setDay] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/ai-costs", { params: day ? { day } : {} }).then(r => { setData(r.data); if (!day) setDay(r.data.day); }).catch(() => setData({ rows: [], total_usd: 0 }));
  }, [day]);

  return (
    <div className="card-panel p-5" data-testid="ai-cost-card">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="eyebrow text-[#FD0F10]">DAILY AI SPEND</div>
          <p className="text-xs text-gray-500 mt-1">Estimated at published rates. Day in UTC.</p>
        </div>
        <input type="date" value={day} onChange={e => setDay(e.target.value)} className="bg-[#0B0C0E] border border-[#2A2E39] rounded px-2 py-1 text-sm" data-testid="ai-cost-day" />
      </div>
      <div className="mt-3 text-sm text-gray-300" data-testid="ai-cost-total">Total: ${(data?.total_usd || 0).toFixed(2)}</div>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-xs" data-testid="ai-cost-table">
          <thead className="text-gray-500 font-mono-ui uppercase">
            <tr><th className="text-left py-1">Email</th><th className="px-2">Plan</th><th className="px-2">Msgs</th><th className="px-2">Voice</th><th className="px-2">Imgs</th><th className="text-right pl-2">USD</th></tr>
          </thead>
          <tbody>
            {(data?.rows || []).map((r, i) => (
              <tr key={`${r.email}-${i}`} className={`border-t border-[#2A2E39] ${r.usd > 1 ? "bg-[#FD0F10]/15 text-white font-bold" : "text-gray-300"}`} data-testid={`ai-cost-row-${r.email}`}>
                <td className="py-1.5 pr-2 break-all">{r.email}</td>
                <td className="text-center">{r.plan}</td>
                <td className="text-center">{r.messages}</td>
                <td className="text-center">{r.voice}</td>
                <td className="text-center">{r.images}</td>
                <td className="text-right">${r.usd.toFixed(3)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && !data.rows.length && <p className="text-xs text-gray-500 mt-2" data-testid="ai-cost-empty">No AI usage recorded for this day.</p>}
      </div>
    </div>
  );
};
